export default "__VITE_ASSET__63e529a5__"